import { GridColDef } from '@mui/x-data-grid';

import { Organization } from 'common';
import {
  addrCityCol,
  addrLine1Col,
  addrLine2Col,
  addrPostalCol,
  addrStateCol,
  addressSummaryCol,
  createdCol,
  emailCol,
  fileLinkCol,
  firstNameCol,
  lastNameCol,
  latitudeCol,
  longitudeCol,
  orgIdCol,
  orgNameCol,
  percentColBaseProps,
  phoneCol,
  statusCol,
  updatedCol,
} from './gridColumns';

export const orgCols: GridColDef<Organization>[] = [
  orgNameCol,
  {
    ...statusCol,
    valueOptions: ['active', 'inactive'], // TODO org status enum (zod)
    filterable: true,
    sortable: false,
    editable: false,
  },
  {
    field: 'contactName',
    headerName: 'Contact Name',
    description: 'Provided primary contact name',
    minWidth: 180,
    flex: 1,
    editable: false,
    filterable: false,
    sortable: false,
    valueGetter: (params) => params.row.primaryContact?.displayName || null,
  },
  firstNameCol,
  lastNameCol,
  {
    ...emailCol,
    valueGetter: (params) => params.row.primaryContact?.email || null,
    field: 'primaryContact.email',
    headerName: 'Contact Email',
    description: 'Provided primary contact email',
    filterable: false,
    sortable: false,
    editable: false,
  },
  {
    ...phoneCol,
    field: 'primaryContact.phone',
    headerName: 'Contact Phone',
    valueGetter: (params) => params.row.primaryContact?.phone || null,
    sortable: false,
    filterable: false,
  },
  {
    ...orgIdCol,
    field: 'tenantId',
    headerName: 'Tenant ID',
  },
  { ...fileLinkCol, field: 'EandOURL', headerName: 'E & O', minWidth: 200 },
  addressSummaryCol,
  addrLine1Col,
  addrLine2Col,
  addrCityCol,
  addrStateCol,
  addrPostalCol,
  latitudeCol,
  longitudeCol,
  {
    field: 'emailDomain',
    headerName: 'Domain',
    minWidth: 140,
    flex: 1,
    editable: false,
    sortable: false,
    filterable: false,
    valueGetter: (params) => params.row.emailDomain || null,
  },
  {
    field: 'enforceDomainRestriction',
    headerName: 'Domain Restriction',
    description:
      'Enforce users under this tenant authenticate with an email matching the "emailDomain"',
    type: 'boolean',
    minWidth: 100,
    flex: 0.5,
    editable: false,
    sortable: false,
    filterable: false,
    valueGetter: (params) => params.row.enforceDomainRestriction || false,
  },
  {
    ...percentColBaseProps,
    field: 'defaultCommission.flood',
    headerName: 'Default Flood Comm.',
    minWidth: 160,
    flex: 1,
    editable: false,
    filterable: false,
    sortable: false,
    valueGetter: (params) => params.row.defaultCommission?.flood || null,
  },
  createdCol,
  updatedCol,
  {
    ...orgIdCol,
    field: 'id',
    headerName: 'Org ID',
  },
];
